enum MenuItemSaleUnit {
  Each = 0,
  LB = 2,
  OZ = 3,
}

export { MenuItemSaleUnit };
